import { ERROR_FRAGMENT } from 'providers/tanstack-query/errors'
import { TypedDocumentNode } from 'providers/tanstack-query/types'
import { gql } from 'providers/tanstack-query/utils'
import { Data, Variables } from './types'

export const UPDATE_AB_TEST: TypedDocumentNode<Data, { input: Variables }> = gql`
  ${ERROR_FRAGMENT}

  mutation updateAbTest($input: UpdateAbTestInput!) {
    updateAbTest(input: $input) {
      abTest {
        status
      }

      errors {
        ...ErrorFragment
      }
    }
  }
`
